<template>
  <div>
    <md-card id="my-settings" align="Left" style="margin-top: 4rem;">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <i class="material-icons">settings</i>
        </div>
        <h4 class="title">Settings</h4>

        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-left" style="padding: 0;">
          <md-app class="my-settings-container">
            <md-app-drawer md-permanent="card">
              <md-list style="padding: 0;">
                <md-list-item :class="{ 'md-selected-list-item': isPasswordChangeSelected }" style="margin-left: 0;">
                  <!-- <md-icon>move_to_inbox</md-icon> -->
                  <span
                    class="md-list-item-text"
                    style="background: #cccccc2e;cursor: pointer;height: 100%;display: flex;justify-content: center;padding-left: 1rem;"
                    @click="currentSettingTab = 'PasswordChange'"
                  >
                    Password Settings
                  </span>
                </md-list-item>

                <md-list-item :class="{ 'md-selected-list-item': isMedicalHistorySelected }" style="margin-left: 0;">
                  <!-- <md-icon>move_to_inbox</md-icon> -->
                  <span
                    v-show="isPatient"
                    class="md-list-item-text"
                    style="background: #cccccc2e;cursor: pointer;height: 100%;display: flex;justify-content: center;padding-left: 1rem;"
                    @click="currentSettingTab = 'MedicalHistory'"
                  >
                    Medical History
                  </span>
                </md-list-item>

                <!-- <md-list-item>
                  <md-icon>send</md-icon>
                  <span class="md-list-item-text">Screening evaluation</span>
                </md-list-item>

                <md-list-item>
                  <md-icon>delete</md-icon>
                  <span class="md-list-item-text">Notifications</span>
                </md-list-item> -->
              </md-list>
            </md-app-drawer>

            <md-app-content>
              <component :is="currentSettingTab"></component>
              <!-- <div>
                <h3 slot="title" class="title">Change Password</h3>
                <p v-if="tempPass" slot="subheader" class="subheader" style="color: red;">You are still using a temporary password, please change it</p>
                <p v-if="!tempPass" slot="subheader" class="subheader">Change your current password</p>

                <md-field slot="inputs" class="md-form-group" style="margin-top: 2rem;">
                  <md-icon>mail_outline</md-icon>
                  <label>Email</label>
                  <md-input :disabled="true" v-model="username" type="email" />
                </md-field>

                <md-field slot="inputs" :class="[
                    { 'md-valid': !errors.has('currentPassword') && touched.currentPassword },
                    { 'md-form-group': true },
                    { 'md-error': errors.has('currentPassword') && touched.currentPassword }
                  ]">
                  <md-icon>lock_outline</md-icon>
                  <label>Current Password</label>
                  <md-input v-model="currentPassword" name="currentPassword" type="password" v-validate="psw1Validation" data-vv-name="currentPassword" />
                </md-field>

                <md-field slot="inputs" :class="[
                    { 'md-valid': !errors.has('psw1') && touched.psw1 },
                    { 'md-form-group': true },
                    { 'md-error': errors.has('psw1') && touched.psw1 }
                  ]">
                  <md-icon>lock_outline</md-icon>
                  <label>New Password</label>
                  <md-input v-model="psw1" name="password" type="password" v-validate="psw1Validation" ref="password" data-vv-name="psw1" />
                </md-field>

                <md-field slot="inputs" :class="[
                    { 'md-valid': !errors.has('psw2') && touched.psw2 },
                    { 'md-form-group': true },
                    { 'md-error': errors.has('psw2') && touched.psw2 }
                  ]">
                  <md-icon>lock_outline</md-icon>
                  <label>Re-enter Password</label>
                  <md-input v-model="psw2" name="password_confirmation" type="password" v-validate="'required|confirmed:password'" data-vv-as="password" data-vv-name="psw2" />
                </md-field>

                <div style="text-align: right;margin-right: 4px;">
                  <md-button slot="footer" class="md-primary" @click="changePassword"> Change Password </md-button>
                </div>
              </div> -->
            </md-app-content>
          </md-app>
        </div>
      </md-card-header>
    </md-card>
  </div>
</template>

<script>
import loader from "@/components/GlobeChek/loader.vue"
import PasswordChange from "./PasswordChange.vue"
import MedicalHistory from "./MedicalHistory.vue"

export default {
  components: {
    PasswordChange,
    MedicalHistory,
    loader
  },
  data() {
    return {
      isPatient: sessionStorage.getItem("usertype") == "Patient",
      username: sessionStorage.getItem("username"),
      isLoading: false,
      currentSettingTab: "PasswordChange"
    }
  },
  computed: {
    isPasswordChangeSelected() {
      return this.currentSettingTab == "PasswordChange"
    },
    isMedicalHistorySelected() {
      return this.currentSettingTab == "MedicalHistory"
    }
  },
  mounted() {
    this.tempPass = sessionStorage.getItem("isTempPsw") === "true"
  }
}
</script>

<style lang="scss" scoped>
  .md-app {
    min-height: 50dvh;
    width: 100%;
    padding: 1rem 1rem 1rem 0;
  }

  .md-drawer {
    width: 230px;
    max-width: calc(100vw - 125px);
  }

  .md-selected-list-item {
    background-color: #d1d1d1;
  }
</style>